import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793b06e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "j-tabs" }
const _hoisted_2 = ["onClick", "data-id"]

import {computed, onMounted, PropType, ref, watchEffect} from "vue";

interface Item {
  id?: string
  name?: string
}


const __default__ = {
  name: "JTabs"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  tabs: {
    type: Array as PropType<Array<Item>>,
    required: true,
    default: []
  },
  direction: {
    type: String,
    required: false,
    default: 'horizontal'
  },
  modelValue: {
    type: String,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props




const itemRefs = ref<HTMLElement[]>([])

const onClick = (id: string) => {
  emit("update:modelValue", id)
}


onMounted(() => {

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(__props.direction)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (x) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (onClick(x.id)),
          "data-id": x.id,
          class: _normalizeClass([{'j-tabs-item-active': __props.modelValue === x.id}, "j-tabs-item"]),
          ref_for: true,
          ref_key: "itemRefs",
          ref: itemRefs
        }, [
          _createElementVNode("div", null, _toDisplayString(x.name), 1)
        ], 10, _hoisted_2))
      }), 256))
    ], 2)
  ]))
}
}

})